import { render, staticRenderFns } from "./AI-Tool-Submit.vue?vue&type=template&id=07834f58&scoped=true&"
import script from "./AI-Tool-Submit.ts?vue&type=script&lang=js&"
export * from "./AI-Tool-Submit.ts?vue&type=script&lang=js&"
import style0 from "./AI-Tool-Submit.less?vue&type=style&index=0&id=07834f58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07834f58",
  null
  
)

export default component.exports